// extracted by mini-css-extract-plugin
module.exports = {"dividerWrapper":"shoppingDivider_dividerWrapper__EMGf8","commentDividerWrapper":"shoppingDivider_commentDividerWrapper__AVzpT","divider":"shoppingDivider_divider__e_nDO"};